// extracted by mini-css-extract-plugin
module.exports = {"bodyContainer":"layout_bodyContainer__y2swc"};
module.exports.__checksum = "f9af292f9686"
